var Haiku = require("@haiku/core");
var _code_circle_code = require("./../circle/code.js");
module.exports = {
  metadata: {
    uuid: "31fbcb64-be05-4425-b6ec-e08f320070d1",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon1",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon1",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/92626370-383e-46ea-94da-c5468a70905a/d1295858d2008135a02c5cb2d36e46917468f646/",
    core: "4.5.0",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: { play: { type: "string", value: "stop", edited: true } },
  eventHandlers: {
    "haiku:Main-03757d2ca1026e0a": {
      hover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "loop" });
        }
      },
      unhover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "stop" });
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:Main-03757d2ca1026e0a": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 81.213,
        "sizeAbsolute.y": 74.053,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Icon1-5a530655b76c73dc": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 30,
        "style.margin": "0",
        "sizeAbsolute.y": 38,
        "sizeMode.y": 1,
        "translation.x": 40.6065,
        "translation.y": 37.0265,
        "style.zIndex": 1
      },
      "haiku:Linear-Gradient-1-A44b9b-659a6a0289f90e07": {
        x1: "25.9791435%",
        y1: "12.6679657%",
        x2: "69.6602845%",
        y2: "86.2801745%"
      },
      "haiku:Stop-663045ddff4d9762": { stopColor: "#EF33F8", offset: "0%" },
      "haiku:Stop-ddc62ab713ff2724": { stopColor: "#F75D4A", offset: "100%" },
      "haiku:Page-1-aed4846ae4b681b4": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Version-Control-Icon-f0eb42befac85cab": {
        fill: "url(#linearGradient-1-a44b9b)",
        fillRule: "nonzero",
        "translation.x": -22,
        "translation.y": -10
      },
      "haiku:Icon1-4cadfdab3a7275f6": {
        d:
          "M47,35.46 L47,31.5333333 C47,29.4382667 45.3175,27.7333333 43.25,27.7333333 L29.5,27.7333333 L29.5,22.54 C32.35,21.9522667 34.5,19.3936 34.5,16.3333333 C34.5,12.8424 31.695,10 28.25,10 C24.805,10 22,12.8424 22,16.3333333 C22,19.3910667 24.15,21.9497333 27,22.54 L27,27.7333333 L27,30.2666667 L27,35.46 C24.15,36.0477333 22,38.6064 22,41.6666667 C22,45.1576 24.805,48 28.25,48 C31.695,48 34.5,45.1576 34.5,41.6666667 C34.5,38.6089333 32.35,36.0502667 29.5,35.46 L29.5,30.2666667 L43.25,30.2666667 C43.94,30.2666667 44.5,30.8341333 44.5,31.5333333 L44.5,35.46 C41.65,36.0477333 39.5,38.6064 39.5,41.6666667 C39.5,45.1576 42.305,48 45.75,48 C49.195,48 52,45.1576 52,41.6666667 C52,38.6089333 49.85,36.0502667 47,35.46 Z M24.5,16.3333333 C24.5,14.2382667 26.1825,12.5333333 28.25,12.5333333 C30.3175,12.5333333 32,14.2382667 32,16.3333333 C32,18.4284 30.3175,20.1333333 28.25,20.1333333 C26.1825,20.1333333 24.5,18.4284 24.5,16.3333333 Z M32,41.6666667 C32,43.7617333 30.3175,45.4666667 28.25,45.4666667 C26.1825,45.4666667 24.5,43.7617333 24.5,41.6666667 C24.5,39.5716 26.1825,37.8666667 28.25,37.8666667 C30.3175,37.8666667 32,39.5716 32,41.6666667 Z M45.75,45.4666667 C43.6825,45.4666667 42,43.7617333 42,41.6666667 C42,39.5716 43.6825,37.8666667 45.75,37.8666667 C47.8175,37.8666667 49.5,39.5716 49.5,41.6666667 C49.5,43.7617333 47.8175,45.4666667 45.75,45.4666667 Z"
      },
      "haiku:Circle-1aaa0a3e0d60b12a": {
        "translation.x": 40.55325,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 38.26975000000001,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 2,
        playback: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        },
        playIt: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        }
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: _code_circle_code,
        attributes: {
          "haiku-id": "Circle-1aaa0a3e0d60b12a",
          "haiku-var": "_code_circle_code",
          "haiku-title": "Circle",
          "haiku-source": "./code/circle/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Icon1-5a530655b76c73dc",
          "haiku-title": "Icon1",
          "haiku-source":
            "designs/AnimatorWebsiteIcon1.sketch.contents/slices/Icon1.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-2302c131ddce6fc2" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-A44b9b-659a6a0289f90e07",
                  id: "linearGradient-1-a44b9b"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-663045ddff4d9762" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-ddc62ab713ff2724" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-aed4846ae4b681b4", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Version-Control-Icon-f0eb42befac85cab",
                  id: "VersionControl-icon"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "Icon1-4cadfdab3a7275f6",
                      id: "Icon1"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon1/code/main/code.js
// module id = 427
// module chunks = 35783957827783